// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCustomFieldsRequestModel from '../../model/get-custom-fields-request-model';
import GetCustomFieldsRequestDTO from '../dto/get-custom-fields-request-dto';
import dtoSchema from '../schemas/get-custom-fields-request-schema';

export default abstract class GetCustomFieldsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCustomFieldsRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetCustomFieldsRequestDTO>): GetCustomFieldsRequestModel;
  static toModel(dto: DeepPartial<GetCustomFieldsRequestDTO> | undefined | null): GetCustomFieldsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCustomFieldsRequestDTO> | undefined | null): GetCustomFieldsRequestModel | undefined {
    return dto ? new GetCustomFieldsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCustomFieldsRequestModel> | GetCustomFieldsRequestModel): GetCustomFieldsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetCustomFieldsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCustomFieldsRequestModel, can not map to GetCustomFieldsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
